import { render, staticRenderFns } from "./project-teams.vue?vue&type=template&id=0d3366e6&scoped=true"
import script from "./project-teams.vue?vue&type=script&lang=js"
export * from "./project-teams.vue?vue&type=script&lang=js"
import style0 from "./project-teams.vue?vue&type=style&index=0&id=0d3366e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3366e6",
  null
  
)

export default component.exports